var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owl-carousel owner-photos-slider"},_vm._l((_vm.slides),function(slide,index){return _c('div',{key:index,staticClass:"item-wrapper"},[_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":slide.imageUrl,"alt":""}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }